import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BCACoursePage: React.FC = () => {
  const courseData = {
    title: "BCA (Bachelor of Computer Applications)",
    shortName: "BCA",
    duration: "3 years",
    description: "Comprehensive computer applications and software development program",
    overview: "Bachelor of Computer Applications (BCA) is a 3-year undergraduate program that provides comprehensive knowledge of computer applications, programming languages, software development, and information technology. This course covers programming, database management, web development, and software engineering, preparing students for careers in IT industry, software development, and system administration.",
    eligibility: [
      "10+2 in any stream",
      "Mathematics as a subject in 12th (preferred)",
      "Minimum 50% marks in 12th standard",
      "Interest in programming and computer applications"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Fundamentals of Computer",
          "Programming in C",
          "Mathematics-I",
          "Digital Electronics",
          "Computer Organization",
          "English Communication"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures",
          "Object Oriented Programming (Java)",
          "Database Management Systems",
          "Operating Systems",
          "Web Development",
          "Software Engineering"
        ]
      },
      {
        year: 3,
        subjects: [
          "Computer Networks",
          "System Analysis and Design",
          "E-Commerce",
          "Mobile Application Development",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Software Developer",
        "Web Developer",
        "System Administrator",
        "Database Administrator",
        "Software Tester",
        "Technical Support Engineer",
        "Mobile App Developer",
        "UI/UX Designer",
        "Business Analyst",
        "Project Manager"
      ],
      industries: [
        "Software Development",
        "IT Services",
        "Web Development",
        "Mobile App Development",
        "E-commerce",
        "Banking and Finance",
        "Healthcare IT",
        "Government IT",
        "Startups",
        "Consulting Firms"
      ],
      averageSalary: "₹3-8 LPA (Fresher), ₹12-35 LPA (Experienced)",
      topRecruiters: [
        "TCS, Infosys, Wipro",
        "Accenture, Cognizant",
        "Amazon, Google, Microsoft",
        "Flipkart, Paytm, Zomato",
        "IBM, Oracle, SAP",
        "Banks and Financial Institutions"
      ]
    },

    admissionProcess: [
      "Merit-based admission on 12th marks",
      "University entrance examinations",
      "Computer aptitude test",
      "Online application and counseling",
      "Interview process in some colleges"
    ],

    topColleges: [
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹75,000 per year",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹85,000 per year",
        ranking: "NIRF Ranking: 25"
      },
      {
        name: "PSG College of Arts and Science",
        location: "Coimbatore",
        fees: "₹60,000 per year",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Madras Christian College",
        location: "Chennai",
        fees: "₹55,000 per year",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Stella Maris College",
        location: "Chennai",
        fees: "₹70,000 per year",
        ranking: "NAAC A+ Grade"
      }
    ],

    skills: [
      "Programming Languages",
      "Database Management",
      "Web Development",
      "Software Testing",
      "Problem Solving",
      "System Analysis",
      "Project Management",
      "Technical Documentation",
      "Version Control",
      "Agile Methodologies"
    ],

    futureScope: "Excellent growth prospects with digital transformation, cloud computing, artificial intelligence, mobile app development, and emerging technologies creating abundant opportunities in IT sector.",

    faqs: [
      {
        question: "What is the difference between BCA and B.Tech CSE?",
        answer: "BCA focuses more on computer applications and software development, while B.Tech CSE covers broader computer science concepts including hardware. BCA is more application-oriented."
      },
      {
        question: "Can I pursue higher studies after BCA?",
        answer: "Yes, you can pursue MCA, M.Sc. IT, MBA, or various certification courses in specialized technologies like cloud computing, data science, or cybersecurity."
      },
      {
        question: "Is mathematics mandatory for BCA?",
        answer: "While mathematics in 12th is preferred, many colleges accept students without mathematics. However, basic mathematical concepts are taught in the program."
      },
      {
        question: "What are the job prospects in the current IT market?",
        answer: "Job prospects are excellent with high demand for software developers, web developers, mobile app developers, and IT professionals across industries, especially in emerging technologies."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BCACoursePage;
